import { inject, Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalIframeComponent } from './modal-iframe.component';

@Injectable({
    providedIn: 'root'
})
export class ModalIframeService {

    private modalService: NgbModal = inject(NgbModal);

    public open(
        titulo: string,
        url: string,
        btnText = 'Cerrar',
        dialogSize: 'sm' | 'md' | 'lg' | 'xl' = 'sm'): Promise<boolean> {
        const modalRef = this.modalService.open(ModalIframeComponent, { size: dialogSize, backdrop: 'static', keyboard: false });
        modalRef.componentInstance.titulo = titulo;
        modalRef.componentInstance.url = url;
        modalRef.componentInstance.btnText = btnText;

        return modalRef.result;
    }

}
